module.exports = __webpack_public_path__ + "img/horizontal_4_4_6000.d2e46da9.png";